import { createClient } from '@supabase/supabase-js'

export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig()

  const supabaseUrl = config.public.SUPABASE_URL
  const supabaseAnonKey = config.public.SUPABASE_ANON_KEY

  // Validate Supabase URL format before attempting to create client
  const isValidUrl = (url: string | undefined): boolean => {
    if (!url) return false
    try {
      const parsed = new URL(url)
      return parsed.protocol === 'http:' || parsed.protocol === 'https:'
    } catch {
      return false
    }
  }

  if (!isValidUrl(supabaseUrl) || !supabaseAnonKey) {
    console.warn('Supabase URL or Anon Key not configured. OAuth features will be disabled.', {
      hasUrl: !!supabaseUrl,
      urlLength: supabaseUrl?.length,
      hasKey: !!supabaseAnonKey
    })
    return {
      provide: {
        supabase: null
      }
    }
  }

  const supabase = createClient(supabaseUrl, supabaseAnonKey, {
    auth: {
      flowType: 'implicit', // Use implicit flow for SPA (simpler, tokens in URL hash)
      autoRefreshToken: false,
      persistSession: false,
      detectSessionInUrl: true
    }
  })

  return {
    provide: {
      supabase
    }
  }
})
